import {
  CartSelectedBundle,
  CartServiceMethodType,
  ShopProfile,
} from "@lemmonhq/types";

export const calculateAllowedOrderServiceMethods = (
  shop: ShopProfile,
): CartServiceMethodType[] => {
  const settings = shop.settings || [];
  const val: any = {
    takeaway: settings.find((el) => el.key == "take_away" && el.value == "yes"),
    delivery: settings.find((el) => el.key == "delivery" && el.value == "yes"),
  };
  const list = Object.keys(val).filter((el) => val[el]);
  //      allowedOrderServiceMethods.value = list;
  return list as CartServiceMethodType[];
};

export const generateCartItemId = (
  productId: number,
  selectedBundles?: CartSelectedBundle[],
  customPrice?: number,
  customerId?: string,
  partitionId?: string,
) => {
  // Ensure bundles and their options are sorted deterministically
  const sortedBundles = selectedBundles
    ? selectedBundles
        .map((bundle) => ({
          bundleId: bundle.bundleId,
          name: bundle.name,
          options: bundle.options
            .map(
              (option) =>
                `${option.id}:${option.entity_id}:${option.entity_type}:${option.title}:${option.price}`,
            )
            .sort() // Sorting options lexicographically ensures order
            .join("|"),
        }))
        .sort((a, b) => a.bundleId - b.bundleId) // Sorting bundles by bundleId
    : [];

  // Construct a deterministic string
  const bundleString = sortedBundles
    .map((bundle) => `${bundle.bundleId}:${bundle.name}:${bundle.options}`)
    .join("||");

  // Construct the final deterministic input string
  const inputString = `${customerId}:${productId}:${
    customPrice ?? "null"
  }::${bundleString}`;

  // Affix partitionId if present
  return partitionId ? `${inputString}::${partitionId}` : inputString;
};
